export default __webpack_public_path__ + "../ckeditor/contents.css";